import { Voucher } from 'gql/graphql';
import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import styles from './VouchersList.module.scss';

interface VouchersListProps {
  onRemoveVoucher: (voucherId: string) => void;
  vouchers: Voucher[];
}

const VouchersList: React.FC<VouchersListProps> = ({ vouchers, onRemoveVoucher }) => {
  return (
    <div className={styles.vouchersSection}>
      {vouchers.map((voucher) => (
        <div className={styles.voucher}>
          <div>
            <div>
              <b>{voucher.name}</b>
            </div>
            <div>Valud until {new Date(voucher.expiration || Date.now()).toLocaleDateString()}</div>
          </div>
          <div className={styles.actions}>
            <span className={styles.label}>{voucher.discount}</span>
            <FaTrashAlt onClick={() => onRemoveVoucher(voucher.id)} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default VouchersList;
